import { theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ParkingCapacity } from 'types/generatedSchemaTypes';
import ZoneDetailsRow from './ZoneDetailsRow';

const ParkingCapacityInfo = ({ capacity }: { capacity: ParkingCapacity }) => {
  const { t } = useTranslation();
  const titleText = () => {
    const free = capacity?.free ?? '';
    const total = capacity?.total ?? '';
    return t('parking.capacityInfo', { available: free, total });
  };

  const parkingIconToBeShownBasedOnCapacity = () => {
    if (capacity?.capacityStatus === 'FULL') {
      return (
        <Icon
          name="ParkingIconForCapacityRed"
          color={theme.colors.aimoUiRed}
          size="m"
        />
      );
    }
    if (capacity?.capacityStatus === 'ALMOST_FULL') {
      return (
        <Icon name="ParkingIconForCapacityOrange" color={'#FFA400'} size="m" />
      );
    }
    return (
      <Icon
        name={'ParkingIconForCapacity'}
        color={theme.colors.boost.green}
        size="m"
      />
    );
  };

  return (
    <ZoneDetailsRow
      title={titleText()}
      icon={parkingIconToBeShownBasedOnCapacity()}
      testIDprefix="parkingCapacity"
      padding={10}
      displayChevronIcon={false}
    />
  );
};

export default ParkingCapacityInfo;
